/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ComponentItemFinderListItem } from '@gh/builder-shared';
import {
  BulkUpdateComponentAddDto,
  BulkUpdateComponentDeleteDto,
  BulkUpdateComponentReplaceDto,
  BulkUpdateHousePlanAddDto,
  BulkUpdateHousePlanDeleteDto,
  BulkUpdateHousePlanReplaceDto,
  BulkUpdateItemReplaceDto,
  ComponentBulkUpdateFilterDto,
  ComponentBulkUpdateListItemDto,
  ItemBulkUpdateListItemDto,
} from '@gh/builder-shared-data';

export type BulkUpdateHousePlanAdd = BulkUpdateHousePlanAddDto;
export type BulkUpdateComponentAdd = BulkUpdateComponentAddDto;
export type ItemBulkUpdateListItem = ItemBulkUpdateListItemDto;
export type ComponentBulkUpdateFilter = ComponentBulkUpdateFilterDto;
export type ComponentBulkUpdateListItem = ComponentBulkUpdateListItemDto;

export type BulkUpdateHousePlanReplace = BulkUpdateHousePlanReplaceDto;
export type BulkUpdateComponentReplace = BulkUpdateComponentReplaceDto;

export type BulkUpdateHousePlanDelete = BulkUpdateHousePlanDeleteDto;
export type BulkUpdateComponentDelete = BulkUpdateComponentDeleteDto;

export const getItemBulkUpdateId = (item: ItemBulkUpdateListItem) => item.id;

export function getBulkUpdateItemModelFromFinder(item: ComponentItemFinderListItem): BulkUpdateItemReplaceDto {
  return {
    id: item.id,
    code: item.code,
    uomId: item.uomId,
  };
}

export function getBulkUpdateItemComponentModelFromFinder(item: ComponentItemFinderListItem): BulkUpdateItemReplaceDto {
  return {
    id: item.id,
    code: item.code,
    uomId: item.uomId,
    isComponent: item.component,
  };
}
